import { useForm } from 'react-hook-form';
import { useContext } from 'react';
import styles from './NewClient.module.scss';
import { Heading } from '../../../../ui/components/Heading/Heading';
import { Input } from '../../../../ui/components/Input/Input';
import { Grid } from '../../../../ui/components/PageBuilder/Grid/Grid';
import { Client } from '../../../../gql/graphql';
import { Button } from '../../../../ui/components/Button/Button';
import { useGQLMutation } from '../../../../ui/utils/graphql';
import { CREATE_CLIENT_AS_ADMIN } from '../../../../graphql/client';
import { InitialContext } from '../../Layout';
import { DatePicker } from '../../../../ui/components/DatePicker/DatePicker';

interface NewClientForm
  extends Omit<Client, 'createdAt' | 'id' | '__typename' | 'companyId'> {}

export const NewClient = () => {
  const { register, handleSubmit, setValue } = useForm<NewClientForm>();
  const { company } = useContext(InitialContext);
  const { mutation } = useGQLMutation<
    Client,
    NewClientForm & { companyId: string }
  >(CREATE_CLIENT_AS_ADMIN, {});

  const onSubmit = (data: NewClientForm) => {
    const splitDate = data.birthday.split('/');
    const day = splitDate?.[0];
    const month = splitDate?.[1];
    const year = splitDate?.[2];
    const newDate = new Date(`${month}-${day}-${year}`);

    mutation({
      variables: {
        name: data.name,
        lastName: data.lastName,
        email: data.email,
        companyId: company.id,
        phoneNumber: data.phoneNumber,
        ext: data.ext,
        birthday: newDate?.toISOString()?.split('T')?.[0],
      },
    });
  };

  return (
    <div className={styles.root}>
      <Heading className={styles.heading} headingLevel="h1">
        Crear nuevo cliente
      </Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid gridColumns={4}>
          <Input
            register={register('name')}
            isRequired
            label="Nombre"
            placeholder="Ejemplo: John"
          />
          <Input
            register={register('lastName')}
            isRequired
            label="Apellido"
            placeholder="Ejemplo: Doe"
          />
          <Input
            isRequired
            register={register('email')}
            label="Email"
            placeholder="Ejemplo: JohnDoe@gmail.com"
          />
          <Input
            register={register('phoneNumber')}
            label="Numero de telefono"
            placeholder="Ejemplo: 3350509015"
          />
          <Input
            register={register('ext')}
            label="Extension de telefono"
            placeholder="Ejemplo: 52"
          />
          <DatePicker
            setValue={setValue}
            name="birthday"
            label="Fecha de nacimiento"
            register={register}
            firstDateAvailable={new Date('02-01-1940')}
            lastDateAvailable={new Date()}
          />
        </Grid>
        <Button type="submit" className={styles.submit}>
          Crear usuario
        </Button>
      </form>
    </div>
  );
};
